<template>
  <footer class="footer px-4 mx-2">
    <div class="row align-items-center justify-content-lg-between">
      <ul class="nav nav-footer">
        <!--   <li class="nav-item">
          <a
            href="https://www.creative-tim.com"
            class="nav-link"
            target="_blank"
            rel="noopener"
            >CREATIVE TIM</a
          >
        </li>
        <li class="nav-item">
          <a
            href="https://www.updivision.com"
            class="nav-link"
            target="_blank"
            rel="noopener"
            >UPDIVISION</a
          >
        </li> -->
        <li class="nav-item">
          <a
            href="https://misepis.com/#"
            class="nav-link"
            target="_blank"
            rel="noopener"
            >Política de privacidad</a
          >
        </li>

        <li class="nav-item">
          <a
            href="https://misepis.com/#"
            class="nav-link"
            target="_blank"
            rel="noopener"
            >Política de cookies</a
          >
        </li>
        <li class="nav-item">
          <a
            href="https://misepis.com/#"
            class="nav-link"
            target="_blank"
            rel="noopener"
            >Aviso legal</a
          >
        </li>
      </ul>
      <div class="col-lg-2">
        <div class="copyright text-center text-lg-center text-muted">
          Versión 1.14.0 (24/09/2026)
        </div>
      </div>
      <div class="col-lg-4">
        <div class="copyright text-center text-lg-right text-muted">
          © {{ year }},
          <a
            href="https://misepis.com/"
            class="font-weight-bold ml-1"
            target="_blank"
            rel="noopener"
            >Misepis</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
